import { useSelector } from 'react-redux';

import { useModifiableSellerSetting } from './use-modifiable-seller-setting';
import { useOnComponentMount } from './use-on-component-mount';
import { useUserHasAccountManagementRole } from './use-user-role';
import { useGlobalModalLaunchContext } from '../contexts/modal-context/global-modal-context';
import { BillingPlanIds } from '../enums/billing-plan-ids';
import { SellerSettings } from '../enums/seller-settings/seller-settings';
import Global from '../store/global-selectors';

export const useLaunchManageSubscriptionDrawerOnFirstLoginAfterTrialAutoConvertedToFree = () => {
  const [isTrialAutoConvertedToFreeNotificationPending, setIsTrialAutoConvertedToFreeNotificationPending] = useModifiableSellerSetting(
    SellerSettings.isTrialAutoConvertedToFreeNotificationPending,
    false,
  );
  const userHasAccountManagementRole = useUserHasAccountManagementRole();
  const currentBillingPlanId = useSelector((state) => {
    const sellerSubscriptionData = Global.selectSellerSubscriptionData(state);
    return sellerSubscriptionData?.currentBillingPlan?.billingPlanId;
  });
  const { openManageSubscriptionDrawer } = useGlobalModalLaunchContext();

  useOnComponentMount(() => {
    if (!isTrialAutoConvertedToFreeNotificationPending) {
      return;
    }

    if (currentBillingPlanId !== BillingPlanIds.Free2025Q2.toString()) {
      // If the user has the notification pending but is not on the free plan, clear the flag since it is not applicable anymore
      setIsTrialAutoConvertedToFreeNotificationPending(false);
      return;
    }

    if (userHasAccountManagementRole) {
      openManageSubscriptionDrawer({ shouldShowTrialAutoConvertedToFreeBanner: true });
      setIsTrialAutoConvertedToFreeNotificationPending(false);
    }
  });
};
